import React from 'react'
import classnames from 'classnames'
import NullDash from './NullDash'

export interface RateCellProps {
  value: number | null | undefined
  /** Decimal places for $/kWh. Default 4. */
  fractionDigits?: number
  className?: string
  /** Optional class for the numeric portion (the $ stays muted). */
  valueClassName?: string
}

/** Table-friendly $/kWh rate: nowrap, tabular number, muted $ prefix with a space. */
export const RateCell: React.FC<RateCellProps> = ({
  value,
  fractionDigits = 4,
  className,
  valueClassName
}) => {
  if (value == null || Number.isNaN(value)) {
    return <NullDash className={className} />
  }
  return (
    <span className={classnames('whitespace-nowrap tabular-nums', className)}>
      <span className="text-xs font-normal text-slate-400 dark:text-slate-400">$</span>
      <span className={classnames('ml-1', valueClassName)}>{value.toFixed(fractionDigits)}</span>
    </span>
  )
}

export default RateCell
